import { EConditionType } from '../../../../json_query';
import { changeOfficeCondition } from '../../../state/advanced/office_condition';
import { getMultiSelectParam } from './abstract_params/multi_select_param';

export const OfficeCondition = getMultiSelectParam<EConditionType>(
  'Состояние',
  [
    { title: 'Офисная отделка', value: EConditionType.OfficeDecoration },
    { title: 'Под чистовую отделку', value: EConditionType.FullDecorationNeeded },
    { title: 'Требуется капитальный ремонт', value: EConditionType.MajorRepairNeeded },
    { title: 'Требуется косметический ремонт', value: EConditionType.CosmeticRepairNeeded },
  ],
  'condition_type',
  changeOfficeCondition,
);
